import * as moment from "moment";
import React from "react";
import { ButtonToolbar } from "react-bootstrap";
import { connect } from "react-redux";
import {
    MessageType,
    dateFormat,
    templateStrings,
} from "../../../../../Constant";
import { defaultMapDispatchToProps } from "../../../../../redux/map-to-props/";
import { routes } from "../../../../../routing/routes";
import {
    AuthenticationService,
    OPERATIONS,
} from "../../../../../services/authorization";
import {
    downloadDispatchData,
    fetchDispatchVehicleDownloads,
} from "../../../../../services/vehicleService";
import { ImportButton, RegionSelector } from "../../../../../shared/components";
import { PageWrapper, TableWrapper } from "../../../../../shared/layout";
import { EpochtoEpochTZ } from "../../../../../shared/utils";
import { Paginator } from "../../../../../shared/widgets";
import PropTypes from "prop-types";

class DispatchDownloadFileList extends React.Component {
  constructor(props) {
    super(props);
    let authorities = localStorage.getItem("authorities");
    this.authService = AuthenticationService.getInstance();
    this.state = {
      authorities: authorities,
      content: [],
      pageNo: 0,
      totalPages: 0,
      totalItems: 0,
    };
    this.supportedTypes = [".xlsx"];
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.getList = this.getList.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    const userRegion = this.authService.getUserFirstRegion();
    if (userRegion) {
      this.updateRightsForRegion(userRegion);
    } else {
      this.updateRightsForRegion(this.state.selectedRegion);
    }
  }

  updateStateForRegion(regionId) {
    this.updateRightsForRegion(regionId);
  }

  updateRightsForRegion(region) {
    this.setState({
      canWrite: this.authService.hasRightForOperationOnRouteInRegion(
        routes.VEHICLE,
        region,
        OPERATIONS.WRITE
      ),
    });
  }

  render() {
    const templatestrings = templateStrings.dispatchVehicleDownload;
    return (
      <div>
        <PageWrapper.Header heading="Dispatch File Import" hideS={false}>
          <div className="pull-right">
            <button
            className="transparent-btn"
              onClick={() => {
                this.fetchVehicleDownloads(this.state.selectedRegion, 0);
              }}
              onKeyDown={() => {}}
            >
              <span className="span-icon-refresh refresh-icon" />
            </button>
          </div>
          {this.state.canWrite && this.state.selectedRegion && (
            <ImportButton
              importKey="dispatch-vehicle"
              regionId={this.state.selectedRegion}
              supportedTypes={this.supportedTypes}
              onMessage={(e, msg) => {
                if (e == MessageType.SUCCESS) {
                  this.props.initiateNotification({ type: e, message: msg });
                  this.fetchVehicleDownloads(this.state.selectedRegion, 0);
                } else if (e == MessageType.ERROR && msg === "Invalid token") {
                  this.props.setTokenExpired(true);
                } else {
                  this.props.initiateNotification({ type: e, message: msg });
                }
              }}
            />
          )}
        </PageWrapper.Header>
        <PageWrapper.Body>
          <PageWrapper.BodyHeader>
            <div className="header-button-container">
              <div className="form-group">
                <p className="filters-label">Filter By:</p>
                <div
                  className="dataTables_length wrapper-gps"
                  id="dataTables-example_length"
                >
                  <ButtonToolbar>
                    <RegionSelector
                      filterKey={routes.VEHICLE}
                      onRegionChange={this.handleRegionChange}
                    />
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </PageWrapper.BodyHeader>
          <TableWrapper>
            <TableWrapper.Header columns={templatestrings} />
            {
              <tbody>
                {this.state.content &&
                  this.state.content.length > 0 &&
                  this.state.content.map((data) => {
                    return this.displayList(data, templatestrings);
                  })}
                {(!this.state.content ||
                  (this.state.content && this.state.content.length === 0)) && (
                  <tr className="gradeA odd noDataStyle" role="row">
                    <td className="sorting_1" colSpan="6">
                      No Data Found !
                    </td>
                  </tr>
                )}
              </tbody>
            }
          </TableWrapper>
          {this.state.content && (
            <Paginator
              pageNo={this.state.pageNo}
              totalPages={this.state.totalPages}
              getList={this.getList}
            />
          )}
        </PageWrapper.Body>
      </div>
    );
  }

  getColor = (status) => {
    switch(status){
      case "Processed":
        return "list-item-green"
      case "Partially Processed":
        return "list-item-red"
      case "InProgress":
        return "list-item-yellow"
      default:
        return "list-item"
    }
  }

  displayList(item) {
    return (
      <tr key={item.id} className="gradeA odd" role="row">
        <td className="list-item">{item.fileName}</td>

        <td className="list-item">
          <span className="protocol">
            {item.uploadedBy ? item.uploadedBy : "NA"}
          </span>
          <div className="protocol-list">
            {item.uploadedBy ? item.uploadedBy : "NA"}
          </div>
        </td>
        <td className="list-item">
          {item.uploadStartAt
            ? moment(
                new Date(
                  EpochtoEpochTZ(
                    parseInt(item.uploadStartAt),
                    localStorage.getItem("timeZone")
                  )
                )
              ).format(dateFormat)
            : "NA"}
        </td>
        <td className="list-item">
          {item.uploadEndAt
            ? moment(
                new Date(
                  EpochtoEpochTZ(
                    parseInt(item.uploadEndAt),
                    localStorage.getItem("timeZone")
                  )
                )
              ).format(dateFormat)
            : "NA"}
        </td>
        <td
          className={this.getColor(item.fileStatus)}
        >
          {item.fileStatus}
        </td>
        <td className="list-item">
          {["Partially Processed", "PartiallyProcessed"].includes(
            item.fileStatus
          ) && (
            <span className="table-icons edit-icon">
              <button 
              className="transparent-btn"
                onClick={() => {
                  this.fileDownloadIndividual(item);
                }}
                onKeyDown={() => {}}
              >
                <span className="download-icon" />
                <span className="protocol-list">Download File</span>
              </button>
            </span>
          )}
        </td>
      </tr>
    );
  }

  fileDownloadIndividual(data) {
    let importId = data.id;
    let fileName = data.fileName;
    downloadDispatchData(importId, fileName)
      .then((res) => {
        console.log("res", res);
      })
      .catch((err) => {
        this.props.initiateNotification({
          type: "error",
          message: err.description
            ? err.description
            : "Error while downloading file",
        });
        console.log("err", err);
      });
  }

  handleRegionChange(region) {
    this.setState({ selectedRegion: region });
    this.fetchVehicleDownloads(region, 0);
    this.updateStateForRegion(region);
  }

  fetchVehicleDownloads(region, pageNo) {
    if (this.mounted) this.props.updateLoader(true);
    fetchDispatchVehicleDownloads(region, pageNo)
      .then((res) => {
        if (this.mounted) {
          this.setState({
            content: res.items,
            totalPages: res.totalPages,
            pageNo: res.currentPage,
            totalItems: res.totalItems,
          });
        }
        this.props.updateLoader(false);
      })
      .catch((err) => {
        this.setState({
          content: [],
          totalPages: 0,
          pageNo: 0,
          totalItems: 0,
        });
        this.errorHandler(err);
        console.log("Err", err);
      });
  }

  errorHandler(err) {
    if (err.status === 401 || err.message === "Invalid token") {
      this.props.setTokenExpired(true);
    } else if (this.mounted) {
      this.props.updateLoader(false);
      this.setState({ content: [] });
      this.props.initiateNotification({
        type: "error",
        message: err.description
          ? err.description
          : "Error while fetching vehicle log data",
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }
  getList(pageNo) {
    if (pageNo >= 0 && pageNo <= this.state.totalPages) {
      this.fetchVehicleDownloads(this.state.selectedRegion, pageNo);
    }
  }
}

export default connect(
  null,
  defaultMapDispatchToProps
)(DispatchDownloadFileList);

DispatchDownloadFileList.propTypes = {
  updateLoader: PropTypes.func,
  setTokenExpired: PropTypes.func,
  initiateNotification: PropTypes.func,
};